


















































import Vue from 'vue'
import Component from 'vue-class-component'
import { Action, Getter } from 'vuex-class'
import {
  FetchBranchesPayload,
  Branch,
  DataTableAction,
  ArchivedPayload,
  CrudDialogMode
} from '../utils/types'
import DataTable from '../components/DataTable.vue'
import BranchCrud from '../components/BranchCrud.vue'
import { DataTableHeader } from 'vuetify'

@Component({
  components: { BranchCrud, DataTable }
})
export default class Branches extends Vue {
  @Action archiveBranch!: (payload: ArchivedPayload) => Promise<boolean>
  @Getter branches!: Branch[]
  @Action createBranch!: (payload: Branch) => Promise<boolean>
  @Action fetchBranches!: (payload: FetchBranchesPayload) => Promise<void>
  @Action updateBranch!: (payload: Branch) => Promise<boolean>
  @Getter totalBranches!: number

  currentCrudDialogMode = CrudDialogMode.NONE
  headers: DataTableHeader[] = [
    { text: 'שם', value: 'name' },
    { text: 'עבודות', value: 'jobs' }
  ]

  isLoading = false
  isViewingArchive = false
  itemsPerPage = 100
  selectedBranch: Branch | null = null

  get actions (): DataTableAction<Branch>[] {
    return [
      {
        text: this.isViewingArchive ? 'הוצאה מהארכיון' : 'העברה לארכיון',
        icon: 'mdi-archive',
        handler: (branch) => this.openCrudDialog(branch, CrudDialogMode.DELETE)
      },
      {
        text: 'עריכה',
        icon: 'mdi-pencil',
        handler: (branch) => this.openCrudDialog(branch, CrudDialogMode.EDIT)
      }
    ]
  }

  get currentDialogTitle () {
    switch (this.currentCrudDialogMode) {
      case CrudDialogMode.CREATE:
        return 'יצירת ענף חדש'
      case CrudDialogMode.EDIT:
        return 'עריכת ענף'
      case CrudDialogMode.DELETE:
        return 'האם את/ה בטוח/ה?'
    }
  }

  get formattedBranches () {
    return this.branches.map((branch) => ({
      ...branch,
      jobs: branch.jobs?.map((job) => job.name).join(', ')
    }))
  }

  get isDialogOpen () {
    return this.currentCrudDialogMode !== CrudDialogMode.NONE
  }

  closeCrudDialog () {
    this.currentCrudDialogMode = CrudDialogMode.NONE
    this.selectedBranch = null
  }

  async handleCrudDialogSubmit (branch: Branch) {
    switch (this.currentCrudDialogMode) {
      case CrudDialogMode.CREATE:
        await this.createBranch(branch)
        break
      case CrudDialogMode.EDIT:
        await this.updateBranch(branch)
        break
      case CrudDialogMode.DELETE:
        await this.changeBranchArchivedState(branch)
        break
    }
    this.closeCrudDialog()
  }

  async fetchPage (page: number): Promise<void> {
    this.isLoading = true
    await this.fetchBranches({
      limit: this.itemsPerPage,
      isArchived: this.isViewingArchive,
      page
    })
    this.isLoading = false
  }

  async handleTableTabChanged (tab: number) {
    this.isLoading = true
    this.isViewingArchive = !!tab
    await this.fetchPage(1)
    this.isLoading = false
  }

  async changeBranchArchivedState (branch: Branch) {
    if (!branch.id) {
      return
    }
    this.isLoading = true
    await this.archiveBranch({
      id: branch.id,
      isArchived: !this.isViewingArchive
    })
    await this.fetchPage(1)
    this.isLoading = false
  }

  openCrudDialog (branch: Branch | null = null, mode: CrudDialogMode = CrudDialogMode.CREATE) {
    this.selectedBranch = branch
    this.currentCrudDialogMode = mode
  }
}
